<template>
  <common-dialog
    ref="dialog"
    width="1000px"
    title="人员选择"
    :enter-save="false"
    in-dialog
    @closed="onClosed"
  >
    <template slot="form">
      <el-tabs v-model="tabName" type="card" @tab-click="onSelectAll">
        <el-tab-pane label="学生" name="student">
          <div class="index-tree-box">
            <div class="left-box" style="height: calc(100vh - 204px);">
              <div class="topSelect">
                <div class="select-label">学期名称：</div>
                <el-select v-model="TermId" @change="termChange">
                  <template v-for="(i,key) in term_list">
                    <el-option :key="key" :value="i.TermId" :label="i.TermName"></el-option>
                  </template>
                </el-select>
              </div>
              <div class="left-title">
                <span style="cursor: pointer;" @click="onSelectAll">所有班级</span>
              </div>
              <div class="left-main">
                <class-tree ref="classTree" @on-select="onSelect" />
              </div>
            </div>
            <div ref="rightbox" class="right-box" v-loading="isLoading">
              <el-form label-width="85px" @keyup.enter.native="getData">
                <div style="display: flex;align-items: flex-start;">
                  <el-form-item label="学生编号">
                    <el-input v-model="st_params.StudentNumber" placeholder="请输入学生编号" clearable />
                  </el-form-item>
                  <el-form-item label="学生姓名">
                    <el-input v-model="st_params.FullName" placeholder="请输入学生姓名" clearable />
                  </el-form-item>
                  <div style="width: 10px;"></div>
                  <el-button type="primary" @click="getData">搜索</el-button>
                  <el-button @click="clear">重置</el-button>
                </div>
              </el-form>
              <el-table
                ref="st_tb"
                border
                :height="tbHeight"
                :data="student_list"
                @select="stSelect"
                @select-all="stSelectAll"
              >
                <el-table-column type="selection" width="45" align="center" />
                <el-table-column prop="StudentNumber" label="学生编号" />
                <el-table-column prop="FullName" label="学生姓名" />
              </el-table>
              <el-pagination
                style="margin-top: 5px; text-align: right"
                :page-size.sync="st_params.PageSize"
                :current-page.sync="st_params.PageIndex"
                :page-sizes="[15,30,50,300,1000,1500]"
                layout="total, sizes, prev, pager, next"
                :total="st_count"
                @size-change="onSizeChange($event,'st')"
                @current-change="onIndexChange($event,'st')"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教职人员" name="teacher">
          <div class="index-tree-box">
            <dp-tree ref="dpTree" @on-select="onSelect" @title-click="onSelectAll" />
            <div class="right-box" v-loading="isLoading">
              <el-form label-width="85px" @keyup.enter.native="getData">
                <div style="display: flex;align-items: flex-start;">
                  <el-form-item label="教师编号">
                    <el-input v-model="te_params.TeacherNumber" placeholder="请输入教师编号" clearable />
                  </el-form-item>
                  <el-form-item label="教师姓名">
                    <el-input v-model="te_params.TeacherName" placeholder="请输入教师姓名" clearable />
                  </el-form-item>
                  <div style="width: 10px;"></div>
                  <el-button type="primary" @click="getData">搜索</el-button>
                  <el-button @click="clear">重置</el-button>
                </div>
              </el-form>
              <el-table
                ref="te_tb"
                border
                :height="tbHeight"
                :data="teacher_list"
                @select="teSelect"
                @select-all="teSelectAll"
              >
                <el-table-column type="selection" width="45" align="center" />
                <el-table-column prop="TeacherNumber" label="教师编号" />
                <el-table-column prop="TeacherName" label="教师姓名" />
              </el-table>
              <el-pagination
                style="margin-top: 5px; text-align: right"
                :page-size.sync="te_params.PageSize"
                :current-page.sync="te_params.PageIndex"
                :page-sizes="[15,30,50,300,1000,1500]"
                layout="total, sizes, prev, pager, next"
                :total="te_count"
                @size-change="onSizeChange($event,'te')"
                @current-change="onIndexChange($event,'te')"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="selectMultiple">选 择</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import listDialogMixins from "@/mixins/listDialog";
import commonDialog from "@/components/common/dialog";
import classTree from "./tree/classTree";
import dpTree from "./tree/dpTree";

export default {
  mixins: [listDialogMixins],
  components: {
    commonDialog,
    classTree,
    dpTree,
  },
  data() {
    return {
      st_select: [],
      te_select: [],
      student_list: [],
      teacher_list: [],
      st_source: [],
      te_source: [],
      term_list: [],
      st_count: 0,
      st_params: {
        PageSize: 15,
        PageIndex: 1,
        FullName: "",
        StudentNumber: "",
        GradeId: null,
        ClassId: null,
      },
      te_count: 0,
      te_params: {
        PageSize: 15,
        PageIndex: 1,
        TeacherName: "",
        TeacherNumber: "",
      },
      LogType: null, //人员下发日志 - 照片/白名单
      isDelete: false,
      TermId: 0,
      isMB: this.$store.state.isMB,
      student_api: require("@/api/st/studentclass").default,
      teacher_api: require("@/api/fa/teacher").default,
      term_api: require("@/api/ed/term").default,
      tabName: "student",
      tbHeight: 0,
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    init(source, LogType, isDelete) {
      if (LogType) this.LogType = LogType;
      if (isDelete) this.isDelete = true;
      this.st_source = source.filter((x) => x.MemberType == 0);
      this.setSelect("st_source", "st_select", "StudentId", "StudentNumber");
      this.te_source = source.filter((x) => x.MemberType == 1);
      this.setSelect("te_source", "te_select", "TeacherId", "TeacherNumber");
      // console.log("st_source", JSON.parse(JSON.stringify(this.st_source)));
      // console.log("te_source", JSON.parse(JSON.stringify(this.te_source)));

      this.tbHeight = this.$refs.rightbox.clientHeight - 37 - 46;
      this.term_api.list({}).then((res) => {
        this.term_list = res.Data || [];
        if (res.Data.length > 0) {
          this.TermId = res.Data[0].TermId;
          this.$refs.classTree.getData(this.TermId);
          this.$refs.dpTree.getData();
          this.onSelectAll();
        }
      });
    },
    termChange() {
      this.$refs.classTree.resetSelect();
      this.$refs.classTree.getData(this.TermId);
      this.onSelectAll();
    },
    getData() {
      this.isLoading = true;
      if (this.tabName == "student") {
        console.log("this.LogType", this.LogType);
        console.log("this.isDelete", this.isDelete);
        var params = this.$commonJs.obj.removeNullKey(this.st_params);
        if (this.LogType == null || this.LogType != 1) {
          if (!this.isDelete) params.HasFace = true;
        }
        this.student_api.list(params).then((res) => {
          this.isLoading = false;
          this.student_list = res.Data;
          this.st_count = res.Count;
          this.$nextTick(() => {
            this.student_list.forEach((x) => {
              var some = this.st_select.some((i) => i.StudentId == x.StudentId);
              if (some) this.$refs.st_tb.toggleRowSelection(x);
            });
          });
        });
      } else {
        var params = this.$commonJs.obj.removeNullKey(this.te_params);
        params.HasFace = true;
        this.teacher_api.list(params).then((res) => {
          this.isLoading = false;
          this.teacher_list = res.Data;
          this.te_count = res.Count;
          this.$nextTick(() => {
            this.teacher_list.forEach((x) => {
              var some = this.te_select.some((i) => i.TeacherId == x.TeacherId);
              if (some) this.$refs.te_tb.toggleRowSelection(x);
            });
          });
        });
      }
    },
    clear() {
      if (this.tabName == "student") {
        this.st_params.PageIndex = 1;
        this.st_params.StudentNumber = "";
        this.st_params.FullName = "";
      } else {
        this.te_params.PageIndex = 1;
        this.te_params.TeacherNumber = "";
        this.te_params.TeacherName = "";
      }
      this.getData();
    },
    setSelect(source, select, key1, key2) {
      this.$nextTick(() => {
        this[source].forEach((x) => {
          var item = {
            ...x,
            [key1]: x.MemberId,
            [key2]: x.MemberNumber,
            FullName: x.MemberName,
          };
          this[select].push(item);
        });
        // console.log(key1, JSON.parse(JSON.stringify(this[select])));
      });
    },
    onSelectAll() {
      if (this.tabName == "student") {
        this.st_params = { ...this.st_params, TermId: this.TermId };
        this.st_params.PageIndex = 1;
        this.st_params.GradeId = null;
        this.st_params.ClassId = null;
        this.st_params.StudentNumber = "";
        this.st_params.FullName = "";
        this.$refs.classTree.resetSelect();
      } else {
        this.te_params = { ...this.te_params, DpIdChain: "" };
        this.te_params.PageIndex = 1;
        this.te_params.TeacherNumber = "";
        this.te_params.TeacherName = "";
      }
      this.getData();
    },
    onSelect(data) {
      // console.log("onSelect", data);
      if (this.tabName == "student") {
        this.st_params = { ...this.st_params, TermId: this.TermId };
        this.st_params.PageIndex = 1;
        if (data.Type == 0) {
          this.st_params.GradeId = data.Id;
          this.st_params.ClassId = null;
        } else {
          this.st_params.GradeId = null;
          this.st_params.ClassId = data.Id;
        }
      } else {
        this.te_params = { ...this.te_params, DpIdChain: data.IdChain };
        this.te_params.PageIndex = 1;
      }
      this.getData();
    },
    stSelect(val, row) {
      this.selectRow(row, "st_select", "StudentId");
    },
    stSelectAll(val) {
      this.selectAll(val, "st_select", "StudentId");
    },
    teSelect(val, row) {
      this.selectRow(row, "te_select", "TeacherId");
    },
    teSelectAll(val) {
      this.selectAll(val, "te_select", "TeacherId");
    },
    selectRow(row, type, key) {
      if (this[type].some((s) => s[key] == row[key])) {
        var index = this[type].findIndex((x) => x[key] == row[key]);
        this[type].splice(index, 1);
      } else {
        this[type].push(row);
      }
    },
    selectAll(rows, type, key) {
      rows.forEach((x) => {
        //判断是否已有数据
        if (!this[type].some((s) => s[key] == x[key])) this[type].push(x);
      });
      var val_ids = rows.map((x) => x[key]);
      //取得需删除的数据
      var del_rows = this[type].filter((x) => !val_ids.includes(x[key]));
      //循环删除
      del_rows.forEach((x) => {
        var index = this[type].findIndex((s) => s[key] == x[key]);
        this[type].splice(index, 1);
      });
    },
    //分页容量大小发生变化时
    onSizeChange(value, type) {
      this[type + "_params"].PageSize = value;
      this.getData();
    },
    onIndexChange(index, type) {
      this[type + "_params"].currentPage = index;
      this.getData();
    },
    selectMultiple() {
      // console.log("st_select", JSON.parse(JSON.stringify(this.st_select)));
      // console.log("te_select", JSON.parse(JSON.stringify(this.te_select)));
      var st_select = this.st_select.map((x) => {
        return {
          MemberId: x.StudentId,
          MemberName: x.FullName,
          MemberNumber: x.StudentNumber,
          MemberType: 0, //学生/教职人员
          DpId: 0,
          DpNames: "",
          GradeId: x.GradeId,
          Grade: x.Grade,
          ClassId: x.ClassId,
          Class: x.Class,
          ClassName: x.ClassName,
        };
      });
      var te_select = this.te_select.map((x) => {
        return {
          MemberId: x.TeacherId,
          MemberName: x.TeacherName,
          MemberNumber: x.TeacherNumber,
          MemberType: 1, //学生/教职人员
          DpId: 0,
          DpNames: x.DpNames,
          GradeId: 0,
          Grade: "",
          ClassId: 0,
          Class: "",
          ClassName: "",
        };
      });
      var data = st_select.concat(te_select);
      this.$emit("select-multiple", data);
      this.close(true);
    },
    onClosed() {
      this.st_select = [];
      this.te_select = [];
      this.student_list = [];
      this.teacher_list = [];
      this.st_source = [];
      this.te_source = [];
      this.term_list = [];
      this.st_count = 0;
      this.te_count = 0;
      this.LogType = null;
      this.isDelete = false;
    },
  },
};
</script>
<style lang="scss">
.index-tree-box {
  .topSelect {
    display: flex;
    padding: 5px 5px;
    .select-label {
      width: 85px;
      line-height: 28px;
    }
  }
  .left-main {
    .chkitem {
      line-height: 28px;
      padding-left: 12px;
      .el-checkbox {
        .el-checkbox__label {
          width: 222px;
          overflow: hidden;
          vertical-align: text-bottom;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right-box {
    padding: 0;
    border: none;
  }
  .right-head {
    font-size: 16px;
    padding-left: 10px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
  }
  .right-tb-head {
    border: 1px solid #e4e7ed;
    border-bottom: none;
    padding: 0 5px 0 10px;
  }
}
</style>